export default function PHP_asXML() {
  return (
    <div>
      <h1>PHP_asXML</h1>
    </div>
  );
}
